<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch" autocomplete="off">
    <el-form-item label="搜索范围">
      <!-- <el-date-picker
        v-model="dateRange"
        type="daterange"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateChange"
      /> -->
      <el-date-picker
        v-model="dateStartRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="开始时间"
        :disabled-date="disabledDate"
        @change="handleDateStartChange"
      />
      <el-date-picker
        v-model="dateEndRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateEndChange"
      />
    </el-form-item>
    <el-form-item label="商品ID">
      <el-input v-model="queryParam.goodsnum" type="textarea" placeholder="多个商品ID使用回车分割" autosize @blur="autoFormat('goodsnum', { unique: true })" />
    </el-form-item>
    <el-form-item label="商品名称">
      <el-input v-model.trim="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <el-form-item label="供应商">
      <el-select
        v-model="queryParam.supplierids"
        filterable
        multiple
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="商品类目">
      <el-cascader
        placeholder="请选择商品类目"
        filterable
        v-model="queryParam.catalogid"
        :options="catalogData"
        :show-all-levels="false"
        :props="catalogQueryProps"
      />
    </el-form-item>
    <el-form-item label="商品类型">
      <el-select
        v-model="queryParam.typeid"
        filterable
        placeholder="商品类型"
      >
        <template v-for="item in goodsTypeData" :key="item.typeid">
          <el-option :label="item.typename" :value="item.typeid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="开票类型">
        <el-select v-model="queryParam.taxtype" placeholder="开票类型">
          <el-option label="增值税专用发票" :value="1" />
          <el-option label="增值税普通发票" :value="2" />
          <el-option label="不开票" :value="3" />
        </el-select>
    </el-form-item>
    <el-form-item label="货源状态">
        <el-select v-model="queryParam.gsstatus" placeholder="货源状态">
          <el-option label="上架" :value="1" />
          <el-option label="下架" :value="2" />
        </el-select>
    </el-form-item>
    <el-form-item label="品牌名称">
      <el-select v-model="queryParam.brandid" 
        filterable 
        multiple         
        placeholder="选择品牌">
        <template v-for="item in brandData" :key="item.brandid">
          <el-option :label="item.name" :value="item.brandid" />
        </template>
      </el-select>
    </el-form-item>
    <el-form-item label="成本价">
      <el-col :span="11">
        <el-form-item prop="lowcostprice1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowcostprice1" :min="0" :precision="2" controls-position="right" placeholder="最小值" class="rangeWidth" />
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowcostprice2">
          <el-input-number v-model="queryParam.lowcostprice2" :min="0" :precision="2" controls-position="right" placeholder="最大值" class="rangeWidth" />
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="市场价">
      <el-col :span="11">
        <el-form-item prop="lowmarketprice1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowmarketprice1" :min="0" :precision="2" controls-position="right" placeholder="最小值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowmarketprice2">
          <el-input-number v-model="queryParam.lowmarketprice2" :min="0" :precision="2" controls-position="right" placeholder="最大值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="商品折扣">
      <el-col :span="11">
        <el-form-item prop="lowdiscount1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowdiscount1" :min="0" :precision="2" :step="0.1" controls-position="right" placeholder="最小值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowdiscount2">
          <el-input-number v-model="queryParam.lowdiscount2" :min="0" :precision="2" :step="0.1" controls-position="right" placeholder="最大值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <!-- <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="商品状态">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
    </el-form-item> -->
    <el-form-item>
      <el-button type="danger" @click="getListGoods">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <!-- <el-button
          type="primary"
          @click="openGoodsType('goods:goodstype')"
          v-hasPermission="['goods:goodstype']"
          >商品类型</el-button
        > -->
        <el-button
          type="primary"
          @click="doGetGoodsTrashList"
          v-hasPermission="['goods']"
          >回收站</el-button>
        <el-button
          type="danger"
          @click="(dialog = true), doGoodsAdd()"
          v-hasPermission="['goods:add']"
          >新增商品</el-button>
        <el-button
          type="danger"
          @click="openImport('goods:import')"
          v-hasPermission="['goods:import']"
          >导入商品</el-button>
        <el-button
          type="danger"
          @click="openImport('goods:importEdit')"
          v-hasPermission="['goods:importEdit']"
          >批量导入修改</el-button>
        <el-button
          type="danger"
          :loading="loadingexport" @click="doExportGoods"
          v-hasPermission="['goods:export']"
          >{{loadingexport ? "处理中 ..." : "导出商品"}}<el-tooltip content="一次最多导出8万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionGoods"
        class="mainTable"
        row-key="goodsid"
        height="600"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="商品ID" prop="goodsnum" width="230"/>
        <el-table-column label="商品类型" prop="typename" width="200"/>
        <el-table-column label="商品名称" prop="name" width="200"/>
        <el-table-column label="商品规格" prop="specification" width="200" />
        <el-table-column label="成本价" align="center" prop="goodsSuppliers[0].costprice">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].costprice" v-text="(scope.row.goodsSuppliers[0].costprice).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="市场价" align="center" prop="goodsSuppliers[0].marketprice">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].marketprice" v-text="(scope.row.goodsSuppliers[0].marketprice).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="销售价" align="center" prop="goodsSuppliers[0].saleprice">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].saleprice" v-text="(scope.row.goodsSuppliers[0].saleprice).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="商品折扣" align="center" prop="goodsSuppliers[0].discount">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].discount" v-text="(scope.row.goodsSuppliers[0].discount*100).toFixed(2) + '%'" />
          </template>
        </el-table-column>
        <el-table-column label="供应商" align="center" prop="goodsSuppliers[0].supplier.name"/>
        <el-table-column label="品牌" align="center" prop="brandname"/>
        <el-table-column label="类目" prop="catalogname" width="150"/>
        <el-table-column label="货源状态" align="center" prop="goodsSuppliers[0].status">
          <template #default="scope">
          <el-tag
              round
              :type="scope.row.goodsSuppliers[0].status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showGoodsStatus(scope.row.goodsSuppliers[0].status)"></span></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="created" width="150">
          <template #default="scope">
            <span v-text="util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')"></span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="状态" prop="status">
            <template #default="scope">
              <el-switch
                :value="scope.row.status"
                :active-value="1"
                :inactive-value="2"
                size="small"
                @change="doGoodsStatus(scope.$index, scope.row, 'status')"
              />
            </template> -->
        <!-- </el-table-column> -->
        <el-table-column label="操作" fixed="right" width="130">
          <template #default="scope">
            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doGoodsEdit(scope.$index, scope.row)"
              v-hasPermission="['goods:edit']"
              >编辑</el-link>

            <el-link
              type="primary"
              size="small"
              @click="open('goods:view', scope.row)"
              v-hasPermission="['goods:view']"
              >供应商</el-link>

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此商品吗？"
              width="200px"
              @confirm="doGoodsDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link>
              </template>
            </el-popconfirm>

            <el-popconfirm
              v-if="scope.row.status===1"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要此商品移到回收站吗？"
              width="200px"
              @confirm="doGoodsTrash(scope.$index, scope.row, 2)"
            >
              <template #reference>
                <el-link
                  v-hasPermission="['goods:remove']"
                  size="small"
                  type="danger"
                  >移到回收站</el-link>
              </template>
            </el-popconfirm>

            <el-popconfirm
              v-if="scope.row.status===2"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要此商品恢复到礼包库吗？"
              width="200px"
              @confirm="doGoodsTrash(scope.$index, scope.row, 1)"
            >
              <template #reference>
                <el-link
                  v-hasPermission="['goods:recover']"
                  size="small"
                  type="danger"
                  >恢复商品库</el-link>
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <div>
        <el-button type="danger" v-if="queryParam.status===1" @click="showBatchGoodsRemoveRecoverDialog('goodsRemove')" v-hasPermission="['goods:remove']">批量移动回收站</el-button>
        <el-button type="danger" v-if="queryParam.status===2" @click="showBatchGoodsRemoveRecoverDialog('goodsRecover')" v-hasPermission="['goods:recover']">批量恢复商品库</el-button>
      </div>
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="55%"
    @close="doGoodsClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="goodsFormRef"
        :model="goodsForm"
        :rules="rules"
        label-width="150px"
        autocomplete="off"
      >
        <el-form-item label="商品类目" prop="catalogid">
          <el-cascader
            style="width: 100%"
            placeholder="请选择商品类目"
            v-model="goodsForm.catalogid"
            :options="catalogData"
            :show-all-levels="false"
            :props="catalogProps"
            @change="getCatalog"
            ref="catalogCascaderRef"
          />
        </el-form-item>

        <el-form-item label="品牌" prop="brandid">
          <el-select
            style="width: 100%"
            v-model="goodsForm.brandname"
            filterable
            placeholder="选择品牌"
            @change="getBrand"
            ref="brandRef"
          >
            <template v-for="item in brandData" :key="item.brandid">
              <el-option :label="item.name" :value="item.brandid" />
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型" prop="typeid">
          <el-select
            style="width: 100%"
            v-model="goodsForm.typename"
            filterable
            placeholder="选择商品类型"
            @change="getGoodsType"
            ref="goodsTypeRef"
          >
            <template v-for="item in goodsTypeData" :key="item.typeid">
              <el-option :label="item.typename" :value="item.typeid" />
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input
            v-model.trim="goodsForm.name"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item label="商品规格" prop="specification">
          <el-input
            v-model.trim="goodsForm.specification"
            type="textarea"
            autosize
            placeholder="请输入商品规格"
          />
        </el-form-item>
        <el-form-item label="商品描述" prop="specification">
          <el-input
            v-model.trim="goodsForm.desc"
            type="textarea"
            autosize
            placeholder="请输入商品描述"
          />
        </el-form-item>
        <el-form-item label="税收编码" prop="taxcode">
          <el-input
            v-model.trim="goodsForm.taxcode"
            placeholder="请输入税收编码"
          />
        </el-form-item>
        <el-form-item label="税收分类名称" prop="taxsort">
          <el-input
            v-model.trim="goodsForm.taxsort"
            placeholder="请输入税收分类名称"
          />
        </el-form-item>
        <el-form-item label="国际条形码" prop="barcode">
          <el-input
            v-model.trim="goodsForm.barcode"
            placeholder="请输入国际条形码"
          />
        </el-form-item>
        <el-form-item label="礼包单品SKU编码" prop="giftsku">
          <el-input
            type="textarea"
            v-model.trim="goodsForm.giftsku"
            placeholder="请输入礼包单品SKU编码"
          />
        </el-form-item>
        <el-form-item label="电商评价数" prop="erate">
          <el-input
            v-model.trim="goodsForm.erate"
            placeholder="请输入电商评价数"
          />
        </el-form-item>
        <el-form-item label="电商链接" prop="elink">
          <el-input
            v-model.trim="goodsForm.elink"
            placeholder="请输入电商链接"
          />
        </el-form-item>
        <el-form-item label="产地" prop="producer">
          <el-input
            v-model.trim="goodsForm.producer"
            placeholder="请输入产地"
          />
        </el-form-item>
        <el-form-item label="发货快递要求" prop="expressdemand">
          <el-input
            v-model.trim="goodsForm.expressdemand"
            placeholder="请输入发货快递要求"
          />
        </el-form-item>
        <el-form-item label="商品备注1" prop="note1">
          <el-input
            v-model.trim="goodsForm.note1"
            type="textarea"
            autosize
            placeholder="请输入商品备注1"
          />
        </el-form-item>
        <el-form-item label="商品备注2" prop="note2">
          <el-input
            v-model.trim="goodsForm.note2"
            type="textarea"
            autosize
            placeholder="请输入商品备注2"
          />
        </el-form-item>

        <el-divider />
        <h1>供应商信息</h1>
        <el-card
          class="box-card"
          shadow="never"
          style="margin-bottom: 10px"
          v-for="(supplier, index) in goodsForm.goodsSuppliers"
          :key="supplier.gsid"
        >
          <template #header>
            <div class="card-header">
              <span>供应商信息（{{ index + 1 }}）</span>
              <el-icon
                @click.prevent="deleteSupplier(supplier)"
                style="float: right;cursor: pointer;"
                ><Close
              /></el-icon>
            </div>
          </template>
          <el-form-item
            label="供应商"
            :prop="'goodsSuppliers.' + index + '.supplierid'"
            :rules="{
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            }"
          >
            <el-select
              style="width:100%"
              v-model="supplier.supplierid"
              filterable
              placeholder="选择供应商"
            >
              <template v-for="item in supplierData" :key="item.supplierid">
                <el-option :label="item.name" :value="item.supplierid" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="供应商商品ID"
            :prop="'goodsSuppliers.' + index + '.sgoodsnum'"
          >
            <el-input
              v-model.trim="supplier.sgoodsnum"
              placeholder="请输入供应商商品ID"
            />
          </el-form-item>
          <el-form-item
            label="成本价"
            :prop="'goodsSuppliers.' + index + '.costprice'"
            :rules="[{
              required: true,
              message: '请输入成本价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.costprice"
              placeholder="请输入成本价"
            />
          </el-form-item>
          <el-form-item
            label="市场价"
            :prop="'goodsSuppliers.' + index + '.marketprice'"
            :rules="[{
              required: true,
              message: '请输入市场价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.marketprice"
              placeholder="请输入市场价"
            />
          </el-form-item>
          <el-form-item
            label="销售价"
            :prop="'goodsSuppliers.' + index + '.saleprice'"
            :rules="[{
              required: true,
              message: '请输入销售价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.saleprice"
              placeholder="请输入销售价"
            />
          </el-form-item>
          <!-- <el-form-item
            label="商品折扣"
            :prop="'goodsSuppliers.' + index + '.discount'"
            :rules="[{
              required: true,
              message: '请输入商品折扣，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.discount"
              placeholder="请输入商品折扣"
            />
          </el-form-item> -->
          <el-form-item
            label="发货地"
            :prop="'goodsSuppliers.' + index + '.delivery'"
          >
            <el-input
              v-model="supplier.delivery"
              placeholder="请输入发货地"
            />
          </el-form-item>
          <el-form-item
            label="发货快递"
            :prop="'goodsSuppliers.' + index + '.express'"
          >
            <el-input
              v-model="supplier.express"
              placeholder="请输入发货快递"
            />
          </el-form-item>
          <el-form-item
            label="货源状态"
            :prop="'goodsSuppliers.' + index + '.status'"
            :rules="{
              required: true,
              message: '请选择货源状态',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="supplier.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="2">下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="默认供应商"
            :prop="'goodsSuppliers.' + index + '.defstatus'"
            :rules="{
              required: true,
              message: '请选择默认供应商',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="supplier.defstatus" @change="changeDefaultStatus(index)">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-card>

        <el-button @click="addSupplier" type="danger">添加供应商</el-button>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doGoodsClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doGoodsSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>

  <BatchGoodsRemoveRecover ref="RefBatchGoodsRemoveRecover" @click="getListGoods"/>

</template>
        
<script setup>
import { ref, onMounted, getCurrentInstance, nextTick  } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listGoods, saveGoods, getGoodsInfo, exportGoods, deleteGoods, updateGoods } from "@/api/goods";
import { listSupplierCache } from "@/api/supplier";
import { listCatalogCache } from "@/api/catalog";
import { listBrandCache } from "@/api/brand";
import { listGoodsTypeCache } from "@/api/goodstype";
import util from "@/util/tool.js";
import storage from  "@/util/storage";

import BatchGoodsRemoveRecover from "@/components/common/batchGoodsRemoveRecover";



// import store from "@/store";

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("goodsPath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.goodsid },
    // query: { name: row.name },
  });
};
let openImport = (routeName)=>{
  router.push({
    name: routeName
  });
}

// let openGoodsType = (routeName)=>{
//   router.push({
//     name: routeName
//   });
// }

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const goodsFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

let title = ref("新增商品");

// let dateRange = ref([]);

let dateStartRange = ref();
let dateEndRange = ref();


const multipleSelection = ref([]);
const doSelectionGoods = (val) => {
  multipleSelection.value = val;
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  brandid: "",
  catalogid: "",
  supplierids: "",
  typeid: "",
  goodsnum: "",
  status: 1,
  taxtype: "",
  isgift: 1,
  gsstatus: "",
  lowcostprice1: null,
  lowcostprice2: null,
  lowmarketprice1: null,
  lowmarketprice2: null,
  lowdiscount1: null,
  lowdiscount2:null,
  created: "",
  changed: "",
});


/**
 * 全局统一失焦格式化方法
 * @param {String} key 表单对象key
 * @param {Object} opt 配置项
 */
const autoFormat = (key, opt = {}) => {
  queryParam.value[key] = util.formatLineText(queryParam.value[key], opt);
};

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: "",
    brandid: "",
    catalogid: "",
    supplierids: "",
    typeid: "",
    goodsnum: "",
    status: 1,
    taxtype: "",
    isgift: 1,
    gsstatus: "",
    lowcostprice1: null,
    lowcostprice2: null,
    lowmarketprice1: null,
    lowmarketprice2: null,
    lowdiscount1: null,
    lowdiscount2:null,
    created: "",
    changed: "",
  };
  defaultDate()
  getListGoods();
};

const goodsForm = ref({
  goodsid: null,
  name: null,
  catalogid: null,
  catalogname: null,
  typeid: null,
  typename: null,
  brandid: null,
  brandname: null,
  specification: "",
  desc: "",
  taxcode: "",
  taxsort: "",
  barcode: "",
  giftsku: "",
  erate: "",
  elink: "",
  producer: "",
  expressdemand: "",
  note1: "",
  note2: "",
  supplierids: "",
  status: 1,
  isgift: 1,
  goodsSuppliers: [
    {
        gsid:null,
        supplierid: null,
        sgoodsnum: "",
        costprice: null,
        marketprice: null,
        saleprice: null,
        discount: null,
        delivery: "",
        express: "",
        status: 1,
        defstatus: 0,
    },
  ],
});

const defaultDate = () => {
  // const today = new Date()
  
  // // 一年前的日期
  // const startDate = new Date(today)
  // startDate.setFullYear(startDate.getFullYear() - 1)

  // // 格式化 YYYY-MM-DD
  // const formatDate = (date) => date.toISOString().slice(0, 10)

  // // 默认赋值
  // dateRange.value = [
  //   formatDate(startDate),
  //   formatDate(today)
  // ]
  // queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
  // queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");

  // dateRange.value = []
  dateStartRange.value = ''
  dateEndRange.value = ''
  queryParam.value.created = ""
  queryParam.value.changed = ""
}
// 2. 禁用逻辑：不能选未来，范围最大一年
const disabledDate = (time) => {
  console.log(time)
  // const now = Date.now()
  // const oneYearMs = 365 * 24 * 60 * 60 * 1000

  // // 禁用未来日期
  // if (time.getTime() > now) return true

  // // 已选开始日期 → 结束日期只能选 开始 ~ 开始+1年
  // if (dateRange.value?.[0]) {
  //   const start = new Date(dateRange.value[0]).getTime()
  //   return time.getTime() < start || time.getTime() > start + oneYearMs
  // }

  // return false
}

// 3. 防止手动输入超过一年范围
// const handleDateChange = () => {
//   if (!dateRange.value) return

  // const start = new Date(dateRange.value[0]).getTime()
  // const end = new Date(dateRange.value[1]).getTime()
  // const oneYearMs = 365 * 24 * 60 * 60 * 1000

  // if (end - start > oneYearMs) {
  //   const maxEnd = new Date(start + oneYearMs)
  //   dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
  // }
//   queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
//   queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
// }

const handleDateStartChange = () => {
  if (!dateStartRange.value) return
  if (dateEndRange.value) {
    if (dateStartRange.value > dateEndRange.value) {
      dateStartRange.value = ""
      queryParam.value.created = ""
      ElMessage.error('开始时间须小于结束时间');
      return false
    }
  }
  queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
}

const handleDateEndChange = () => {
  if (!dateEndRange.value) return

  if (dateStartRange.value > dateEndRange.value) {
    dateStartRange.value = ""
    queryParam.value.created = ""
    ElMessage.error('开始时间须小于结束时间');
    return false
  }
  queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
}


//批量移到回收站
let dialogBatchGoodsRemoveRecoverVisible = ref(false);
const RefBatchGoodsRemoveRecover = ref();
const showBatchGoodsRemoveRecoverDialog = (flag) => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的商品项');
    return false
  }
  RefBatchGoodsRemoveRecover.value.changeVisible(!dialogBatchGoodsRemoveRecoverVisible.value);

  let goodsids = []

  multipleSelection.value.forEach((goods) => {
      goodsids.push(goods.goodsid.toString())
  });

  RefBatchGoodsRemoveRecover.value.goodsRemoveRecoverMethod({
    goodsid: goodsids,
    status: flag==='goodsRemove'?2:1,
    flag: flag
  });
};


const changeDefaultStatus = (index) => {
  goodsForm.value.goodsSuppliers.forEach((supplier,i) => {
    if (index != i) {
      goodsForm.value.goodsSuppliers[i].defstatus = 0
    }
  });
};

const catalogCascaderRef = ref()
const getCatalog = ()=> {
    //console.log(val)
    // console.log(catalogCascaderRef.value.getCheckedNodes()[0].label)
    // console.log(catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > '))
    goodsForm.value.catalogname = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')+'||'+catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > ');
    // goodsForm.value.catalogid = val.slice(-1) 
    //console.log('-catalogCascaderRef.value.-',catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(','))
    //goodsForm.value.catalogid = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')

}

let currentInstance = null
const brandRef = ref()
const getBrand = (selectedValue) => {
  nextTick(() => {
     // 这里不加nextTick会获取不到准确的值
    const {selectedLabel} = currentInstance.refs.brandRef
    goodsForm.value.brandname = selectedLabel
    goodsForm.value.brandid = selectedValue
  })
}

const goodsTypeRef = ref()
const getGoodsType = (selectedValue) => {
  nextTick(() => {
     // 这里不加nextTick会获取不到准确的值
    const {selectedLabel} = currentInstance.refs.goodsTypeRef
    goodsForm.value.typename = selectedLabel
    goodsForm.value.typeid = selectedValue
  })
}

const addSupplier = () => {
  goodsForm.value.goodsSuppliers.push({
    supplierid: null,
    sgoodsnum: "",
    costprice: null,
    marketprice: null,
    saleprice: null,
    discount: null,
    delivery: "",
    express: "",
    status: 1,
    defstatus: 0
  });
};
const deleteSupplier = (supplier) => {
  const index = goodsForm.value.goodsSuppliers.indexOf(supplier);
  if (index !== -1) {
    goodsForm.value.goodsSuppliers.splice(index, 1);
  }
};

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("goodsPath")
  if (query) {
    queryParam.value = query
  }

  currentInstance = getCurrentInstance();

  defaultDate()

  getListGoodsType();
  getListBrand();
  getListSupplier();
  getListCatalog();
  getListGoods();

});

//商品类型列表API
const goodsTypeData = ref([]);
const goodsTypeReset = (goodsTypes) => {
  let dataTmp = [];
  goodsTypes.forEach((goodsType) => {
    goodsType.typeid = goodsType.typeid.toString();
    dataTmp.push(goodsType);
  });
  return dataTmp;
};
const getListGoodsType = () => {
  listGoodsTypeCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    goodsTypeData.value = goodsTypeReset(res.data.extend.pages.list);
  });
};

//品牌列表API
const brandData = ref([]);
const brandReset = (brands) => {
  let dataTmp = [];
  brands.forEach((brand) => {
    brand.brandid = brand.brandid.toString();
    dataTmp.push(brand);
  });
  return dataTmp;
};
const getListBrand = () => {
  listBrandCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    brandData.value = brandReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//类目API
const catalogQueryProps = ref({
  checkStrictly: true,
  multiple: true,
  //expandTrigger: "hover",
  emitPath: false,
  value: "catalogid",
  label: "name",
});
const catalogData = ref([]);
const catalogProps = ref({
  //checkStrictly: true,
  //expandTrigger: "hover",
  emitPath: false,
  value: "catalogid",
  label: "name",
});
const catalogReset = (catalogs) => {
  let dataTmp = [];
  catalogs.forEach((catalog) => {
    catalog.catalogid = catalog.catalogid.toString();
    catalog.parentid = catalog.parentid.toString();
    dataTmp.push(catalog);
    catalogReset(catalog.children);
  });
  return dataTmp;
};
const getListCatalog = () => {
  listCatalogCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    catalogData.value = catalogReset(res.data.extend.pages.list);
  });
};

const doGoodsAdd = () => {
  title.value = "新增商品";
  resetForm()
  // goodsForm.value.goodsSuppliers = [
  //     {
  //       gsid: null,
  //       supplierid: null,
  //       sgoodsnum: "",
  //       costprice: null,
  //       marketprice: null,
  //       discount: null,
  //       status: 1
  //     },
  //   ]
};

const doGoodsDelete = (index, obj) => {
  console.log(obj.goodsid.toString())
  deleteGoods(obj).then((res) => {
    if (res.data.code === 1) {
      getListGoods();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

//回收站列表
const doGetGoodsTrashList = () => {
  queryParam.value.status = 2
  getListGoods();
}

//回收站
const doGoodsTrash = (index, obj, status) => {
  console.log(obj.goodsid.toString())
  updateGoods({status, goodsid:obj.goodsid.toString(), name: obj.name}).then((res) => {
    if (res.data.code === 1) {
      getListGoods();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}


const doGoodsEdit = (index, obj) => {
  // console.log(index,obj)
  title.value = "编辑商品";
  // goodsForm.value = obj;//直接赋值会出问题


  goodsForm.value.catalogname = obj.catalogid+'||'+obj.catalogname
  console.log(goodsForm.value.catalogname)

  let goodsid = obj.goodsid.toString()

  getGoodsInfo({ goodsid}).then((res) => {
    goodsForm.value = res.data.extend.goods;
    goodsForm.value.goodsid = res.data.extend.goods.goodsid.toString()
    let catalogids = (res.data.extend.goods.catalogid).split(',')
   // console.log('catalogids----',catalogids,catalogids[catalogids.length-1])
    goodsForm.value.catalogid = catalogids[catalogids.length-1]
    //console.log('goodsForm.value.catalogid---',goodsForm.value.catalogid)
    //goodsForm.value.catalogid = res.data.extend.goods.catalogid.toString()
    goodsForm.value.brandid = res.data.extend.goods.brandid.toString()

    let goodsSuppliers = res.data.extend.goods.goodsSuppliers;

    let dataTmp = [];

    goodsSuppliers.forEach((supplier) => {
        supplier.supplierid = supplier.supplierid.toString();
        supplier.gsid = supplier.gsid.toString();
        //supplier.status = supplier.gsstatus;
        // supplier.discount = supplier.costprice / supplier.marketprice;
        dataTmp.push(supplier);

    });
    goodsForm.value.goodsSuppliers = dataTmp
  });
};

const doGoodsClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  goodsFormRef.value.resetFields()
};

const resetForm = () => {
  goodsForm.value = {
    goodsid: null,
    name: null,
    catalogid: null,
    catalogname: null,
    typeid: null,
    typename: null,
    brandid: null,
    brandname: null,
    specification: "",
    desc: "",
    taxcode: "",
    taxsort: "",
    barcode: "",
    giftsku: "",
    erate: "",
    elink: "",
    producer: "",
    expressdemand: "",
    note1: "",
    note2: "",
    supplierids: "",
    status: 1,
    isgift: 1,
    goodsSuppliers: [
      {
          gsid:null,
          supplierid: null,
          sgoodsnum: "",
          costprice: null,
          marketprice: null,
          saleprice: null,
          discount: null,
          delivery: "",
          express: "",
          status: 1,
          defstatus: 0,
      },
    ],
  };
};

const doGoodsSave = () => {
  goodsFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    goodsForm.value.catalogname = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')+'||'+catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > ');


    let defstatusFlag = 0
    goodsForm.value.goodsSuppliers.forEach((supplier) => {
        supplier.discount = supplier.costprice / supplier.marketprice;
        if (supplier.defstatus===1) {
          defstatusFlag = 1
        }
    });
    if (!defstatusFlag) {
      ElMessage.error('请为商品设置默认供应商')
      return
    }

    console.log(goodsForm.value.goodsSuppliers)

    saveGoods(goodsForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListGoods();
          doGoodsClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新用户状态
//   const doGoodsStatus = (index, obj) => {
//     let status = obj.status == 1 ? 2 : 1;
//     let data = { status, name: obj.name, goodsid: obj.goodsid.toString() };
//     tableData.value[index].status = status;
//     saveGoods(data);
//   };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListGoods();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListGoods();
};

//商品表API
const getListGoods = () => {
  storage.remove('goodsPath')

  if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }
  
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.brandname = query.brandid?query.brandid.join(','):''
  query.supplierids = query.supplierids?query.supplierids.join(','):''
  query.catalogid = query.catalogid?query.catalogid.join(','):''
  delete query.brandid
  console.log(query)

  listGoods(query).then((res) => {//queryParam.value
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = res.data.extend.pages.list;
    loadingData.value = false
  });
};

// const getGoodsInfos = (goodsid)=>{
//     getGoodsInfo({ goodsid}).then((res) => {
//         console.log(res)
//     });
// }

const doExportGoods = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  //queryParam.value.pageSize = 5000;
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.brandname = query.brandid?query.brandid.join(','):''
  query.supplierids = query.supplierids?query.supplierids.join(','):''
  query.catalogid = query.catalogid?query.catalogid.join(','):''
  query.pageSize = 80000
  delete query.brandid

  loadingexport.value = true;
  exportGoods(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};


const validateDecimal = (rule, value, callback) => {
  //   const reg = /^d*(?:.d{0,2})?$/;
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入商品名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "名称长度2到200",
      trigger: "blur",
    },
  ],
  catalogid: [
    {
      required: true,
      message: "请选择类目",
      trigger: "change",
    },
  ],
  typeid: [
    {
      required: true,
      message: "请选择商品类型",
      trigger: "change",
    },
  ],
  brandid: [
    {
      required: true,
      message: "请选择品牌",
      trigger: "change",
    },
  ],
  // specification: [
  //   {
  //     message: "请填写商品规格",
  //     trigger: "blur",
  //   },
  //   {
  //     min: 2,
  //     max: 100,
  //     message: "规格长度2到100",
  //     trigger: "blur",
  //   },
  // ],
});
</script>